import { bindStateToDb, createKeyAtPath } from '@/utilities/db-helpers'

const battles = {
  namespaced: true,

  state: () => ({
    currentKey: null,
    userBattles: {},
  }),

  getters: {
    battle: state =>
      state.currentKey || window.localStorage.getItem(`recentBattle`),

    getUserBattles: ({ userBattles }) => userBattles || {},
  },

  actions: {
    bindUserBattlesRef: bindStateToDb(`userBattles`, `userBattles`),

    setCurrent: ({ commit }, payload) => {
      return commit(`doSetCurrent`, payload)
    },

    create: ({ dispatch, rootGetters }, data) => {
      const { uid: owner } = rootGetters[`accounts/user`]
      data.id = createKeyAtPath(`/battles`)

      const updates = {
        [`/battles/${data.id}`]: {
          ...data,
          owner,
          round: 1,
          turn: 0,
        },
        [`/userBattles/${owner}/${data.id}`]: data,
      }

      return dispatch(`updateDb`, updates, { root: true })
    },

    destroy: async ({ dispatch, rootGetters }, id) => {
      const { uid: owner } = rootGetters[`accounts/user`]
      const combatantIds = await rootGetters[`battle/combatantIds`](id)

      // remove combatants from battle
      if (combatantIds) await dispatch(`depopulate`, { id, combatantIds })

      // then delete battle
      const updates = {
        [`/battles/${id}`]: null,
        [`/userBattles/${owner}/${id}`]: null,
        [`/battleCombatants/${id}`]: null,
      }

      return dispatch(`updateDb`, updates, { root: true })
    },

    depopulate: ({ dispatch }, { id, combatantIds }) => {
      const updates = {}
      Object.keys(combatantIds).forEach(combatantId => {
        updates[`/combatants/${combatantId}/battles/${id}`] = null
      })

      return dispatch(`updateDb`, updates, { root: true })
    },
  },

  mutations: {
    doSetCurrent(state, payload) {
      state.currentKey = payload
    },
  },
}

export default battles
export const { mutations, actions } = battles
